import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    RoutingComponent
} from './routing.component';
import {SharedModule} from '../../shared/shared.module';
import {CoreModule} from '../../core/core.module';
import {FlowModule} from '../flow/flow.module';
import {
    BuildCMSConditionsPipe,
    ChannelNamePipe,
    GetErrorMessagePipe,
    PlaceholderDisplayPipe,
    RenamePropertyPipe,
    ApiUrlPipe, ChannelIntegrationPipe
} from './routing.pipe';
import {RouteApiTokenService} from './services/route-api-token.service';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CoreModule,
        FlowModule,
    ],
    declarations: [
        RoutingComponent,
        ChannelNamePipe,
        RenamePropertyPipe,
        BuildCMSConditionsPipe,
        GetErrorMessagePipe,
        PlaceholderDisplayPipe,
        ApiUrlPipe,
        ChannelIntegrationPipe
    ],
  exports: [
    RoutingComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
    providers: [
        RouteApiTokenService
    ]
})
export class RoutingModule { }
